/*
 * @Author: zyq
 * @Date: 2022-10-19 09:57:01
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-25 11:59:05
 * @description:
 */
import Vue from 'vue'
import Vuex from 'vuex'
import moduleUser from './user'
import moduleMusic from './music'
// import { login } from '@/api/user/login'
// import { getToken, setToken } from '@/utils/auth'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    m_user: moduleUser,
    m_music: moduleMusic
  }
})

export default store
